import React, { useState } from "react";
import { Layout, Menu, Switch } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import {
  DashboardOutlined,
  UserOutlined,
  FileOutlined,
  TeamOutlined,
  ProjectOutlined,
  SettingOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  BulbOutlined,
  SelectOutlined,
  EnvironmentOutlined ,
  HomeOutlined,
  FileTextOutlined,
  IdcardOutlined
} from "@ant-design/icons";
import DashboardHeader from "./Header";

const { Content, Sider } = Layout;

const DashboardLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);


  const wrapLabel = (label) => (
    <span style={{
      wordWrap: "break-word",
      whiteSpace: "normal",
      lineHeight: "1.4", // Adjust line spacing between wrapped lines
      display: "inline-block", // Ensures spacing applies properly
    }}>
      {label}
    </span>
  );
  const menuItems = [
    {
      key: "dashboard",
      icon: <DashboardOutlined />,
      label:wrapLabel("Dashboard"),
      path: "/",
    },
    {
      key: "survey",
      icon: <BulbOutlined />,
      label: wrapLabel("Surveys"),
      path: "/surveys",
    },
    {
      key: "map-view-survey",
      icon: <EnvironmentOutlined />,
      label: wrapLabel("Survey Maps"),
      path: "/survey-map",
    },  
    {
      key: "users",
      icon: <UserOutlined />,
      label: "Users",
      path: "/users",
    }, 
   
    {
      key: "settings",
      icon: <SettingOutlined />,
      label: "Settings",
      children: [
        // {
        //   key: "wards",
        //   icon: <TeamOutlined />,
        //   label: wrapLabel("Ward Master"),
        //   path: "/wards",
        // },

        // {
        //   key: "profile",
        //   icon: <TeamOutlined />,
        //   label: "Profile",
        //   path: "/profile",
        // },

        {
          key: "change-password",
          icon: <TeamOutlined />,
          label: wrapLabel("Change Password"),
          path: "/change-password",
        },
        // {
        //   key: "departments",
        //   icon: <TeamOutlined />,
        //   label: "Departments",
        //   path: "/departments",
        // },
        // {
        //   key: "mohallas",
        //   icon: <TeamOutlined />,
        //   label: wrapLabel("Mohalla Master"),
        //   path: "/mohallas",
        // },
        // {
        //   key: "categories",
        //   icon: <TeamOutlined />,
        //   label: wrapLabel("Property Category"),
        //   path: "/categories",
        // },

        // {
        //   key: "commercial-categories",
        //   icon: <TeamOutlined />,
        //   label: wrapLabel("Commercial Category"),
        //   path: "/commercial-categories",
        // },
        // {
        //   key: "commercial-sub-categories",
        //   icon: <TeamOutlined />,
        //   label: wrapLabel("Commercial Sub Category"),
        //   path: "/commercial-sub-categories",
        // },
        // {
        //   key: "constructions",
        //   icon: <TeamOutlined />,
        //   label: wrapLabel("Nature of Construction"),
        //   path: "/constructions",
        // },
        // {
        //   key: "property-status",
        //   icon: <TeamOutlined />,
        //   label: "Property Status",
        //   path: "/property-status",
        // },
        // {
        //   key: "property-type",
        //   icon: <TeamOutlined />,
        //   label: "Property Type",
        //   path: "/property-type",
        // },
      ]
    },
  ];

  const getSelectedKey = () => {
    const path = location.pathname;
    const selectedKeys = [];
    
    // Helper function to find menu item by path
    const findMenuItemByPath = (items, targetPath) => {
      for (const item of items) {
        if (item.path === targetPath) {
          return item.key;
        }
        if (item.children) {
          const childKey = findMenuItemByPath(item.children, targetPath);
          if (childKey) {
            selectedKeys.push(item.key); // Add parent key
            return childKey;
          }
        }
      }
      return null;
    };

    const key = findMenuItemByPath(menuItems, path);
    if (key) {
      selectedKeys.push(key);
    }
    
    return selectedKeys;
  };

  return (
    <Layout
      style={{
        minHeight: "100vh",
        background: isDarkMode ? "#141414" : "#f0f2f5",
      }}
    >
      <Sider
        collapsed={collapsed}
        onCollapse={setCollapsed}
        style={{
          overflow: "auto",
          height: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          bottom: 0,
          background: isDarkMode ? "#1f1f1f" : "#ffffff",
          boxShadow: "2px 0 8px 0 rgba(29,35,41,.05)",
        }}
      >
        <div
          style={{
            height: "64px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 16px",
            borderBottom: `1px solid ${
              isDarkMode ? "#303030" : "rgba(0,0,0,.06)"
            }`,
          }}
        >
          {collapsed ? (
            <MenuUnfoldOutlined
              onClick={() => setCollapsed(false)}
              style={{
                fontSize: "18px",
                cursor: "pointer",
                color: isDarkMode ? "#fff" : "#000",
              }}
            />
          ) : (
            <>
              <MenuFoldOutlined
                onClick={() => setCollapsed(true)}
                style={{
                  fontSize: "18px",
                  cursor: "pointer",
                  color: isDarkMode ? "#fff" : "#000",
                }}
              />
              {/* <Switch
                checkedChildren={<BulbOutlined />}
                unCheckedChildren={<BulbOutlined />}
                checked={isDarkMode}
                // onChange={setIsDarkMode}
              /> */}
            </>
          )}
        </div>
        <Menu
          theme={isDarkMode ? "dark" : "light"}
          selectedKeys={getSelectedKey()}
          mode="inline"
          items={menuItems}
          onClick={({ key }) => {
            const findItemPath = (items) => {
              for (const item of items) {
                if (item.key === key) return item.path;
                if (item.children) {
                  const path = findItemPath(item.children);
                  if (path) return path;
                }
              }
              return null;
            };
            
            const path = findItemPath(menuItems);
            if (path) {
              navigate(path);
            }
          }}
          style={{
            borderRight: "none",
            background: isDarkMode ? "#1f1f1f" : "#ffffff",
          }}
        />
      </Sider>
      <Layout
        style={{
          marginLeft: collapsed ? 80 : 200,
          transition: "all 0.2s",
          background: isDarkMode ? "#141414" : "#f0f2f5",
        }}
      >
        <DashboardHeader isDarkMode={isDarkMode} />
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            background: isDarkMode ? "#1f1f1f" : "#ffffff",
            borderRadius: 6,
            minHeight: 280,
          }}
        >
          {React.cloneElement(children, { isDarkMode })}
        </Content>
      </Layout>
    </Layout>
  );
};

export default DashboardLayout;
